import styled from "styled-components";
import SVG from "react-inlinesvg";

export const RadioContainer = styled.div`
    align-items: center;
    color: ${({ $disabled }) => ($disabled ? "#ccc" : "#006560")};
    cursor: pointer;
    display: flex;
    font-size: 16px;

    input[type="radio"] {
        display: none;
    }

    label {
        color: ${({ $disabled }) => ($disabled ? "#A3A3A3" : "#006560")};
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .radio-circle {
        width: 16px;
        height: 16px;
        border: 2px solid ${({ $disabled }) => ($disabled ? "#A3A3A3" : "#006560")};
        border-radius: 50%;
        margin-right: 8px;
        position: relative;
    }

    input:checked + .radio-circle::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 8px;
        height: 8px;
        background: #006560; 
        border-radius: 50%;
        transform: translate(-50%, -50%);
    }
`;

export const Help = styled(SVG)`
    height: 12px;
    margin-left: 4px;
    width: 12px;
    & path {
        fill: currentColor;
    }
`;